export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5179.2ae80ddf.jpg";